export const pvData1 =[
    {
        cumulationPowerKWh: 0,
        objectID: "",
        powerKW: 0,
        powerKWh: 0,
        time: 15,
        __typename: "MonitorData"
    },
    {
        cumulationPowerKWh: 0,
        objectID: "",
        powerKW: 0,
        powerKWh: 0,
        time: 30,
        __typename: "MonitorData"
    },
    {
        cumulationPowerKWh: 0,
        objectID: "",
        powerKW: 0,
        powerKWh: 0,
        time: 45,
        __typename: "MonitorData"
    },
    {
        cumulationPowerKWh: 0,
        objectID: "",
        powerKW: 0,
        powerKWh: 0,
        time: 60,
        __typename: "MonitorData"
    },
    {
        cumulationPowerKWh: 0,
        objectID: "",
        powerKW: 0,
        powerKWh: 0,
        time: 75,
        __typename: "MonitorData"
    },
    {
        cumulationPowerKWh: 0,
        objectID: "",
        powerKW: 0,
        powerKWh: 0,
        time: 90,
        __typename: "MonitorData"
    },
    {
        cumulationPowerKWh: 0,
        objectID: "",
        powerKW: 0,
        powerKWh: 0,
        time: 105,
        __typename: "MonitorData"
    },
    {
        cumulationPowerKWh: 0,
        objectID: "",
        powerKW: 0,
        powerKWh: 0,
        time: 120,
        __typename: "MonitorData"
    },
    {
        cumulationPowerKWh: 0,
        objectID: "",
        powerKW: 0,
        powerKWh: 0,
        time: 135,
        __typename: "MonitorData"
    },
    {
        cumulationPowerKWh: 0,
        objectID: "",
        powerKW: 0,
        powerKWh: 0,
        time: 150,
        __typename: "MonitorData"
    },
    {
        cumulationPowerKWh: 0,
        objectID: "",
        powerKW: 0,
        powerKWh: 0,
        time: 165,
        __typename: "MonitorData"
    },
    {
        cumulationPowerKWh: 0,
        objectID: "",
        powerKW: 0,
        powerKWh: 0,
        time: 180,
        __typename: "MonitorData"
    },
    {
        cumulationPowerKWh: 0,
        objectID: "",
        powerKW: 0,
        powerKWh: 0,
        time: 195,
        __typename: "MonitorData"
    },
    {
        cumulationPowerKWh: 0,
        objectID: "",
        powerKW: 0,
        powerKWh: 0,
        time: 210,
        __typename: "MonitorData"
    },
    {
        cumulationPowerKWh: 0,
        objectID: "",
        powerKW: 0,
        powerKWh: 0,
        time: 225,
        __typename: "MonitorData"
    },
    {
        cumulationPowerKWh: 0,
        objectID: "",
        powerKW: 0,
        powerKWh: 0,
        time: 240,
        __typename: "MonitorData"
    },
    {
        cumulationPowerKWh: 0,
        objectID: "",
        powerKW: 0,
        powerKWh: 0,
        time: 255,
        __typename: "MonitorData"
    },
    {
        cumulationPowerKWh: 0,
        objectID: "",
        powerKW: 0,
        powerKWh: 0,
        time: 270,
        __typename: "MonitorData"
    },
    {
        cumulationPowerKWh: 0,
        objectID: "",
        powerKW: 0,
        powerKWh: 0,
        time: 285,
        __typename: "MonitorData"
    },
    {
        cumulationPowerKWh: 0,
        objectID: "",
        powerKW: 0,
        powerKWh: 0,
        time: 300,
        __typename: "MonitorData"
    },
]

export const pvData2 = [
    {
        cumulationPowerKWh: 0,
        objectID: "",
        powerKW: 0,
        powerKWh: 0,
        time: 1215,
        __typename: "MonitorData"
    },
    {
        cumulationPowerKWh: 0,
        objectID: "",
        powerKW: 0,
        powerKWh: 0,
        time: 1230,
        __typename: "MonitorData"
    },
    {
        cumulationPowerKWh: 0,
        objectID: "",
        powerKW: 0,
        powerKWh: 0,
        time: 1245,
        __typename: "MonitorData"
    },
    {
        cumulationPowerKWh: 0,
        objectID: "",
        powerKW: 0,
        powerKWh: 0,
        time: 1260,
        __typename: "MonitorData"
    },
    {
        cumulationPowerKWh: 0,
        objectID: "",
        powerKW: 0,
        powerKWh: 0,
        time: 1275,
        __typename: "MonitorData"
    },
    {
        cumulationPowerKWh: 0,
        objectID: "",
        powerKW: 0,
        powerKWh: 0,
        time: 1290,
        __typename: "MonitorData"
    },
    {
        cumulationPowerKWh: 0,
        objectID: "",
        powerKW: 0,
        powerKWh: 0,
        time: 1305,
        __typename: "MonitorData"
    },
    {
        cumulationPowerKWh: 0,
        objectID: "",
        powerKW: 0,
        powerKWh: 0,
        time: 1320,
        __typename: "MonitorData"
    },
    {
        cumulationPowerKWh: 0,
        objectID: "",
        powerKW: 0,
        powerKWh: 0,
        time: 1335,
        __typename: "MonitorData"
    },
    {
        cumulationPowerKWh: 0,
        objectID: "",
        powerKW: 0,
        powerKWh: 0,
        time: 1350,
        __typename: "MonitorData"
    },
    {
        cumulationPowerKWh: 0,
        objectID: "",
        powerKW: 0,
        powerKWh: 0,
        time: 1365,
        __typename: "MonitorData"
    },
    {
        cumulationPowerKWh: 0,
        objectID: "",
        powerKW: 0,
        powerKWh: 0,
        time: 1380,
        __typename: "MonitorData"
    },
    {
        cumulationPowerKWh: 0,
        objectID: "",
        powerKW: 0,
        powerKWh: 0,
        time: 1395,
        __typename: "MonitorData"
    },
    {
        cumulationPowerKWh: 0,
        objectID: "",
        powerKW: 0,
        powerKWh: 0,
        time: 1410,
        __typename: "MonitorData"
    },
    {
        cumulationPowerKWh: 0,
        objectID: "",
        powerKW: 0,
        powerKWh: 0,
        time: 1425,
        __typename: "MonitorData"
    },
    {
        cumulationPowerKWh: 0,
        objectID: "",
        powerKW: 0,
        powerKWh: 0,
        time: 1440,
        __typename: "MonitorData"
    },
]